<template>
    <div>
        <v-data-table :headers="headers" :items="data" hide-actions class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr @click="editSurvey(props.item)">
                    <td class="text-xs-left">{{getSurveyStatus(props.item)}}</td>
                    <td class="text-xs-left">{{props.item["status"]}}</td>
                    <td class="text-xs-left">{{props.item["survey_name"]}}</td>
                    <td class="text-xs-left">{{props.item["subject_name"]}}</td>
                    <td class="text-xs-left">{{props.item["date"]}}</td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {getUnixtime, unixtimeToFormattedDatetime} from "@/utils/datetime.js"
export default {
    props: {
        data: { required: true },
    },
    data() {
        return {
            headers: [
                {
                    text: "提出期限",
                    value: "status",
                    align: 'left',
                    sortable: false,
                },
                {
                    text: "回答ステータス",
                    value: "status",
                    align: 'left',
                    sortable: false,
                },
                {
                    text: "サーベイ名",
                    value: "survey_name",
                    align: 'left',
                    sortable: false,
                },
                {
                    text: "対象者名",
                    value: "subject_name",
                    align: 'left',
                    sortable: false,
                },
                {
                    text: "提出日",
                    value: "date",
                    align: 'left',
                    sortable: false,
                },

            ]
        }

    },
    methods: {
        editSurvey: function (item) {
            this.$emit("editItem", item)
        },
        getSurveyStatus(item){
            const now = getUnixtime()
            let status = "test"
            if(now <= item.start_date){
                status = unixtimeToFormattedDatetime(item.start_date) + "より受付開始"
            }
            else if (now <= item.pre_end_date){
                status = unixtimeToFormattedDatetime(item.pre_end_date) + "まで受付中"
            }
            else if (now <= item.end_date){
                status = unixtimeToFormattedDatetime(item.end_date) + "まで受付延長"
            }else if (now > item.end_date){
                status = "受付終了"
            }
            return status
        }
    }
}
</script>
